<template>
  <div>
    <div id="users">
      <b-alert
        show
        variant="info"
      >
        The list below displays the first 100 users and groups in alphabetical order.
        If you're looking for a specific user or group, please enter your search criteria to find them.
      </b-alert>
      <b-form-input
        v-model.lazy="searchTerm"
        v-debounce="_getUsersAndGroups"
        placeholder="Please type to search for users and groups"
        class="mb-3"
      />
      <div class="user__security--content">
        <div
          v-if="loading"
          class="spinner__container"
        >
          <content-spinner :show="loading" />
        </div>
        <template v-else>
          <user-component
            v-for="user in users.data"
            :key="user.id"
            :user="user"
          />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import {createNamespacedHelpers} from 'vuex';
import ContentSpinner from '../../../core/components/ContentSpinner';
import PermissionCard from '../components/PermissionCardComponents/PermissionCard.vue';
import UserComponent from '@/modules/Security/components/UserComponent.vue';

const {mapState, mapActions} = createNamespacedHelpers('dataManagement');
const {
  mapState: mapStateUser,
  mapActions: mapActionsUser,
} = createNamespacedHelpers('user');

export default {
  name: 'UsersView',
  components: {
    UserComponent,
    PermissionCard,
    ContentSpinner,
  },
  data() {
    return {
      searchTerm: null,
      loading: false,
    };
  },
  computed: {
    ...mapStateUser(['users']),
  },
  methods: {
    ...mapActionsUser(['getUsersAndGroups', 'getUsersPermissions']),
    async _getUsersAndGroups() {
      this.loading = true;
      await this.getUsersAndGroups(this.searchTerm);
      this.loading = false;
    },
  },
  async mounted() {
    this.loading = true;
    await this.getUsersPermissions();
    await this.getUsersAndGroups();
    this.loading = false;
  },
};
</script>

<style scoped lang="scss">
.user__security--content {
  position: relative;
  height: 72vh;
  overflow-y: auto;

  & .spinner__container {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>